import { toString as queryToString } from '@/utils/url';
import { useRouter } from 'next/router';
import { useState } from 'react';

export default function useListFilter() {
  const router = useRouter();
  const query: ObjectType = router.query;
  const [filterCheckBoxArr, setFilterCheckBoxArr] = useState([]);

  const updateQueryUrl = function (newQuery: ObjectType, path?: string, withoutShallow?: boolean, noReplace?: boolean) {
    // let filters = filtersObj ? JSON.stringify(filtersObj) : filtersObj;
    // let _filtersObj = filtersObj ? filtersObj : parseFiltersProp(query?.filters);
    // const newFilter = _filtersObj?.catalogue_num ? { catalogue_num: _filtersObj?.catalogue_num } : {};
    // if (filterCheckBoxArr.length > 0) {
    //   let newArr = [];
    //   filterCheckBoxArr.map(item => {
    //     if (item.type === 'boolean') {
    //       newFilter[item.filterKey] = item.filterValue;
    //     } else {
    //       newArr = [...newArr, item.filterValue];
    //       newFilter[item.filterKey] = newArr.toString();
    //     }
    //   });
    // }

    // let _queryObj = queryObj && JSON.parse(JSON.stringify(queryObj));
    // if (!_queryObj.offset) _queryObj.offset = defaultOffset;
    // if (!_queryObj.limit) _queryObj.limit = defaultLimit;

    // let newQuery = {
    //   ...query,
    //   ..._queryObj,
    //   filters
    // };
    const pathname = path ? path : router.pathname;
    const fullUrl = `${pathname}${queryToString(newQuery)}`;
    if (router.asPath === fullUrl) {
      //如果url完全相同不继续跳转
      return;
    }
    if (!!noReplace) {
      router.replace(fullUrl, undefined, {
        shallow: withoutShallow ? false : true,
        //@ts-ignore
        __no_replace: 1
      });
      return;
    }
    router.replace(fullUrl, undefined, {
      shallow: withoutShallow ? false : true
    });
    // history.pushState({}, '', `${queryToString(newQuery)}`);
  };

  const updatePathWithQuery = function (path, withoutQueries = ['category']) {
    const _newQuery = { ...query };
    withoutQueries.forEach(key => delete _newQuery[key]);
    router.replace(`${path + queryToString(_newQuery)}`);
  };

  return {
    filterCheckBoxArr,
    setFilterCheckBoxArr,
    updateQueryUrl,
    updatePathWithQuery
  };
}
